<script>
	import { getContext } from "svelte";
	import { tweened } from "svelte/motion";
	import { cubicOut } from "svelte/easing";
	import { fade, blur, fly, slide, scale } from "svelte/transition";
	import { animationParameters } from "../stores";

	import { line, curveMonotoneX } from "d3-shape";

	import { px } from "../utils.js";

	const { data, xGet, yGet, zGet, xScale, yScale, xRange, yRange, xDomain, yDomain, y } =
		getContext("LayerCake");

	export let dataE;
	export let strokeWidth = 5;
	$: coordinatesE = dataE ? dataE.map((d) => [$xGet(d), $yGet(d)]) : null;

	$: coordinates = $data.map((group) => group.values.map((d) => [$xGet(d), $yGet(d)]));

	const tCoordinates = tweened(coordinates, $animationParameters);
	$: tCoordinates.set(coordinates);

	// $: path = (values) => {
	// 	return (
	// 		"M" +
	// 		values
	// 			.map((d) => {
	// 				return $xGet(d) + "," + $yGet(d);
	// 			})
	// 			.join("L")
	// 	);
	// };

	/*
	$: tPath = (group, i) => {
		return (
			"M" +
			$tCoordinates[i]
				.map((d) => {
					return d[0] + "," + d[1];
				})
				.join("L")
		);
  };
  */

	$: path = line()
		.x((x) => x[0])
		.y((x) => x[1])
		.curve(curveMonotoneX);
</script>

{#if dataE}
	<g class="line-group" transition:fade={$animationParameters}>
		<path
			class="path-line"
			d={path(coordinatesE)}
			stroke={"#B5B5B5"}
			stroke-width={px(strokeWidth)}
		/>
	</g>
{:else}
	<g class="line-group" transition:fade={$animationParameters}>
		{#each $data as group, i}
			<!-- <path class="path-line" d={path(group.values)} stroke={$zGet(group)} /> -->
			<!--<path class="path-line" d={tPath(group, i)} stroke={$zGet(group)} stroke-width={"5px"} />-->
			<path
				class="path-line"
				d={path($tCoordinates[i])}
				stroke={$zGet(group)}
				stroke-width={px(strokeWidth)}
			/>
		{/each}
	</g>
{/if}

<style>
	.path-line {
		fill: none;
		stroke-linejoin: round;
		stroke-linecap: round;
		transition: stroke 1s ease-in;
		/* stroke-width: 3px; */
	}
</style>
